
import barba from '@barba/core'
import * as d3 from "d3"

class barChart{

    constructor(el,data){
        this.backgroundColor = "rgba(238, 237 ,247, 1)"
        this.padding = 30
        this.dataset = data
        this.el = d3.select(el)
        this.svg = this.el.append("svg")
        this.rendar()
        setTimeout(() => {
            this.update()
            this.resize()
        }, 200);
    }
    rendar (){
        
        this.x = this.svg.append("g")
        .attr("class", "axis axis-x")

        this.y = this.svg.append("g")
        .attr("class", "axis axis-y")

        this.addRects()
    }
    update() {
        this.width = this.el.node().clientWidth
        this.height = this.el.node().clientHeight - this.padding
        this.addScales()
        
        this.setRects()
    }
    resize (){
        window.addEventListener("resize", () => {
            this.update()
        })
    }
    addScales(){
        
        this.xTicks = 5

        this.xScale = d3.scaleBand()
        .domain(this.dataset.map((d) => { return d.label }))
        .range([0,this.width])


        // Y軸を値のスケールに設定する
        this.yScale = d3.scaleLinear()
        .domain([0,d3.max(this.dataset, (d) => { return d.value})])
        // SVG内でのY軸の位置の開始位置と終了位置を指定しY軸の幅を設定する
        .range([this.height, this.padding])

        // scaleをセットしてX軸を作成
        this.axisx = d3.axisBottom(this.xScale)
    
        // scaleをセットしてY軸を作成
        this.axisy = d3.axisLeft(this.yScale)

        // X軸の位置を指定し軸をセット
        this.x.attr("transform", "translate(" + 0 + "," + (this.height) + ")")  
        .call(this.axisx) 
    
        // Y軸の位置を指定し軸をセット
        this.y.attr("transform", "translate(" + this.padding + "," + 0 + ")")
        .call(this.axisy)
    }
    addRects(){
        this.rectGroup = this.svg.append("g")
        this.rects = this.rectGroup.selectAll(".bar")
        .data(this.dataset)
        .enter()
        .append("g")
        .attr('class',"rect-grp")
        .append("rect")
        .attr('class',"bar")
        .style("fill", this.backgroundColor )

        this.labels = this.rectGroup.selectAll(".rect-grp")
        .append("text")
        .text( (d) => { return d.value + '%' })
        .attr('class',"bar-label")

    }
    setRects(){
        this.barWidth = this.xScale.bandwidth() / 2
        
        this.rects
        .attr("y", (d) => { 
            return this.yScale(d.value) 
        })
        .attr("x", (d) =>  { 
            return this.xScale(d.label) + (this.barWidth / 2)
        })
        .attr("width", (d) =>  { 
            return this.barWidth 
        })
        .attr("height", (d) =>  { 
            let h = this.yScale(0) - this.yScale(d.value)
            if(Math.sign(h) < 0){
                h = -(h)
            }
            return h
        })
        this.labels
        .attr("y", (d) => { 
            return this.yScale(d.value) - 10
        })
        .attr("x", (d,i) =>  { 
            const length = String(d.value).length + 1
            return this.xScale(d.label) + (this.barWidth) - (length * 5.5)
        })
    }
}

export default class{

	constructor(){

       
          
		barba.hooks.afterOnce((data) => {
            this.init()
        })
        
        barba.hooks.after((data) => {
            this.init()
        })
        
    }
    
    init(){

        const barCharts = document.querySelectorAll('[data-barchart]')
        if(barCharts.length > 0){
            barCharts.forEach((c)=>{
                
                const data = JSON.parse(c.getAttribute('data-dataset'))
                
                new barChart(c, data)
            })
        }
    }    
}